import { hasAccessToSubmitRequest } from '../../../shared/has-access-to-submit-request';
/**
 * @param {string} token
 */
export const getHasAccessToSubmitRequest = async (token) => {
  return hasAccessToSubmitRequest(token);
};
